// extracted by mini-css-extract-plugin
export default {"strip":"Marquee_strip__YJN5q","inner":"Marquee_inner__qqLbH","marquee":"Marquee_marquee__4ROPc","dot":"Marquee_dot__ybWUu"};